module.exports = __webpack_public_path__ + "img/layout-text-window-reverse.7a35091f.svg";